export const EASING = 'cubic-bezier(0.5, 0.5, 0.76, 0.76)';